/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ConnectorState,
    ConnectorStateFromJSON,
    ConnectorStateFromJSONTyped,
    ConnectorStateToJSON,
} from './';

/**
 * 
 * @export
 * @interface ConnectorStatus
 */
export interface ConnectorStatus {
    /**
     * 
     * @type {ConnectorState}
     * @memberof ConnectorStatus
     */
    state: ConnectorState;
    /**
     * 
     * @type {string}
     * @memberof ConnectorStatus
     */
    workerId?: string;
}

export function ConnectorStatusFromJSON(json: any): ConnectorStatus {
    return ConnectorStatusFromJSONTyped(json, false);
}

export function ConnectorStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectorStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'state': ConnectorStateFromJSON(json['state']),
        'workerId': !exists(json, 'worker_id') ? undefined : json['worker_id'],
    };
}

export function ConnectorStatusToJSON(value?: ConnectorStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'state': ConnectorStateToJSON(value.state),
        'worker_id': value.workerId,
    };
}

